import { Dispatch, SetStateAction } from 'react';
import { uploadWorkspaceLogo } from '@/api/workspace';
import { LOGOS } from '@/const/logos';
import { IDefaultLogo } from '../../../interfaces/logo.interface';

type TGenerateDataToUpdate = {
  formValues: any;
  activeWorkspace: any;
  defaultLogo: string | null;
  isLogoUploaded: string | null;
  setLogoUploaded: Dispatch<SetStateAction<string | null>>;
}

const generateDataToUpdate = async ({
    formValues,
    activeWorkspace,
    defaultLogo,
    isLogoUploaded,
    setLogoUploaded,
}: TGenerateDataToUpdate) => {
    const { image: currentImage, color: currentColor } = activeWorkspace;
    let image: string = currentImage;
    let color: string = currentColor;

    if (formValues.logo && formValues.logo.length > 0) {
        if (isLogoUploaded) {
            image = isLogoUploaded;
        } else {
            const uploadRes = await uploadWorkspaceLogo(formValues.logo[0].originFileObj);
            setLogoUploaded(uploadRes.data.thumbnail);
            image = uploadRes.data.thumbnail;
        }
    }

    if (!formValues.logo && defaultLogo) {
        const defaultLogoFind: IDefaultLogo | undefined = LOGOS.driver.find(
            (logo) => logo.type === defaultLogo,
        );

        if (defaultLogoFind) {
            image = defaultLogoFind.url;
            color = defaultLogoFind.color;
        }
    }

    return {
        name: formValues.name,
        country: formValues.country,
        countryCodeName: formValues.countryCodeName,
        coverageCities: formValues.coverageCities,
        coverageDistance: formValues.coverageDistance,
        maxBatching: formValues.maxBatching,
        searchMaxDistance: formValues.searchMaxDistance,
        image,
        color,
    };
};

export {
    generateDataToUpdate,
};
